import { formatDateIgnoreTimezone } from "@roc/feature-utils";
import { formatCurrency, formatNumberWithCommas, formatPercentage } from "@roc/ui/utils";
import moment from "moment";

function parseDateField(value) {
  if (!value) {
    return null;
  }
  const date = value instanceof Date ? moment(value) : moment(value, ["YYYY-MM-DD", "MM/DD/YYYY"], true);
  return date.isValid() ? date : null;
}

export function formatDateField(value) {
  const date = parseDateField(value);
  if (date) {
    return formatDateIgnoreTimezone(date.toDate());
  } else {
    return "-";
  }
}

export function toMMDDYYYY(value) {
  const date = parseDateField(value);
  return date ? date.format("MM/DD/YYYY") : null;
}

export function hasValue(value) {
  return value !== null && value !== undefined && value !== '';
}

export function formatCurrencyField(value) {
  if (isNaN(value) || !value) {
    return "-";
  }
  return formatCurrency(value, 0);
}

export function formatPercentageField(value) {
  if (isNaN(value) || !value) {
    return "-";
  }
  return formatPercentage(value);
}

export function formatNumberField(value, minDecimals = 0, maxDecimals = 0) {
  let res = value;
  if (res && typeof res === 'string') {
    res = Number(res.replace(/,/g, ''));
  }

  if (isNaN(res) || !res) {
    return "-";
  }
  return formatNumberWithCommas(res, minDecimals, maxDecimals);
}

export function convertStringNumberToNumber(value) {
  if (value && typeof value === 'string') {
    return Number(value.replace(/,/g, ''));
  }
  return value;
}

export function getStringOrDefault(value) {
  if (value) {
    return value;
  }
  return "-";
}

export function formatBooleanField(value) {
  return value ? "Yes" : "No";
}

export function formatBooleanFieldOrDefault(value, defaultString = "-") {
  if (value === true) return "Yes";
  if (value === false) return "No";
  return defaultString;
}

export function getFullAddress({ address, city, state, zipCode }) {
  return `${address}, ${city}, ${state} ${zipCode}`;
}

export function chunkArray(array, size = 3) {
  const result = [];
  for (let i = 0; i < array.length; i += size) {
    result.push(array.slice(i, i + size));
  }
  return result;
}

export function valueOrDash(value) {
  return value == null ? "-" : value;
}